import { render, staticRenderFns } from "./PwdSet.vue?vue&type=template&id=ed95f61e"
import script from "./PwdSet.vue?vue&type=script&lang=js"
export * from "./PwdSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports